import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonalInformationComponent } from './personal-information.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { SuccessMessageComponent } from 'src/app/components/success-message/success-message.component';
import { DateDefaultFormatPipe } from 'src/app/pipes/date-format.pipe';
import { ClickOutsideDirective } from 'src/app/directives/click-outside.directive';



@NgModule({
  declarations: [
    PersonalInformationComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode'
    }),
    ClickOutsideDirective,
    ComponentsModule,
    DateDefaultFormatPipe,
  ],
  providers: [
    SuccessMessageComponent
  ]
})
export class PersonalInformationModule { }
